import {
  faSearch,
  faTrashCan,
  faFileCirclePlus,
  faFileMagnifyingGlass,
} from "@fortawesome/pro-solid-svg-icons";

export const documentYears = [
  "2025",
  "2024",
  "2023",
  "2022",
  "2021",
  "2020",
  "2019",
  "2018",
  "2017",
  "2016",
  "2015",
  "2014",
  "2013",
];

export const documentPeriodOptions = ["Mese", "Trimestre", "Personalizzato"];

export const monthMapping: { [key: string]: number } = {
  Gennaio: 0,
  Febbraio: 1,
  Marzo: 2,
  Aprile: 3,
  Maggio: 4,
  Giugno: 5,
  Luglio: 6,
  Agosto: 7,
  Settembre: 8,
  Ottobre: 9,
  Novembre: 10,
  Dicembre: 11,
};

export const trimestersOptions = [
  "1° Trimestre",
  "2° Trimestre",
  "3° Trimestre",
  "4° Trimestre",
];

export const trimestersMonths = [
  { startMonth: 0, endMonth: 2 }, // Q1
  { startMonth: 3, endMonth: 5 }, // Q2
  { startMonth: 6, endMonth: 8 }, // Q3
  { startMonth: 9, endMonth: 11 }, // Q4
];

export const emptyPagesData = {
  CESTINO: {
    icon: faTrashCan,
    title: "Cestino vuoto",
    desc: "I documenti nel cestino verranno eliminati definitivamente dopo 30 giorni.",
  },
  NO_RESULTS_FROM_FILTERS: {
    icon: faFileMagnifyingGlass,
    title: "Nessun risultato corrispondente",
    desc: "Modifica i filtri o prova a cercare per nome o contenuto",
  },
  NO_RESULTS_FROM_SEARCH: {
    icon: faFileCirclePlus,
    title: "Spazio vuoto",
    desc: "Non hai ancora caricato nessun file",
  },
};
